<app-stages [stages]="stages" currentStage="Załączniki">
</app-stages>
<br>
@if (!pending() && !loading()) {
  @if (contentUrl; as url) {
    <app-execution-of-traffic-organization-projects-map
      (close)="contentUrl = null"
      [contentUrl]="url">
    </app-execution-of-traffic-organization-projects-map>
  }
  <div class='row'>
    @if (feeCategory(); as feeCategory) {
      <div class="col-12" style="padding-right: 1.5rem">
        <app-alert [noIcon]="true" alertTitle="**UWAGA!**" [closable]="false">
          <div class="text-justify">
            W celu dokonania płatności online zostaniesz przeniesiony do nowej karty. <br> Po dokonaniu płatności należy
            dołączyć potwierdzenie przelewu:
            <a target="_blank"
               title="Link otwierany w nowej zakładce przeglądarki"
               routerLink="/login"
               [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
              <strong>
                Przejdź do płatności online
              </strong>
            </a>
            <p class="mt-2">
              Opłatę skarbową za pełnomocnictwo przedłożone w formie elektronicznej za pośrednictwem systemu
              teleinformatycznego należy uiścić na konto organu podatkowego właściwego ze względu na miejsce
              zamieszkania
              lub siedzibę mocodawcy. W przypadku udzielenia pełnomocnictwa lub prokury przez więcej niż jednego
              mocodawcę
              w jednym dokumencie, właściwym organem jest organ podatkowy właściwy ze względu na miejsce zamieszkania
              albo
              siedzibę mocodawcy wskazanego jako pierwszy, który ma miejsce zamieszkania albo siedzibę na terytorium
              Rzeczypospolitej Polskiej. Należy samodzielnie ustalić właściwy organ podatkowy i wnieść opłatę na jego
              numer rachunku bankowego.
              Prezydent Miasta stołecznego Warszawy jest właściwym organem, jeżeli mocodawca albo żaden z mocodawców
              ustanawiających pełnomocnictwo lub prokurę w jednym dokumencie nie ma miejsca zamieszkania albo siedziby
              na
              terytorium Rzeczypospolitej Polskiej.
              W przypadku gdy miejsce zamieszkania lub siedziba mocodawcy znajduje się w mieście Dębica powołane opłaty
              skarbowe należy uiścić poprzez
              <a target="_blank"
                 title="Link otwierany w nowej zakładce przeglądarki"
                 routerLink="/login"
                 [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
                <strong>Przejdź do płatności online</strong>
              </a>
              lub poza portalem na konto: Urząd Miejski w
              Dębicy, ul. Ratuszowa 2, 39-200 Dębica, nr rachunku bankowego PEKAO S.A:
              <strong>29 1240 4764 1111 0000 4863 34 19</strong>
              <a
                class="ms-2"
                appCopyToClipboard="29 1240 4764 1111 0000 4863 34 19"
                href="#" role="button">
                <i aria-hidden="true" class="fa fa-copy"></i>
                <span class="sr-only">Kopiuj numer konta do schowka</span>
              </a>
            </p>
          </div>
        </app-alert>
      </div>
    }
    <div class='col-12'>
      <form novalidate autocomplete='off' [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
        <ol>
          @for (item of attachmentsPositions(); track item.tag) {
            <li>
              <div class='row'>
                <div class='col-md-7'>
                  <p>
                    @if (item.required) {
                      *
                    } {{ item.description }}
                  </p>
                  @if ((item.description === 'Projekt organizacji ruchu') && !!application()?.porId) {
                    @if (application()?.porAssignmentApplication | application | async; as app) {
                      @if (app?.description; as url) {
                        <br>
                        <app-alert [closable]="false" type="info">
                          Otwórz wybrany projekt i wygeneruj wydruk, który należy tu dołączyć:
                          <a href="#" role="button" class="btn btn-tertiary icon-btn"
                             (click)="$event.preventDefault(); contentUrl = url">
                            <i aria-hidden="true" class='fa fa-file-alt'></i>
                            Otwórz
                          </a>
                        </app-alert>
                      }
                    }
                  }
                </div>
                <div class='col-md-5'>
                  @if (form.getFormControlByName(item.tag); as control) {
                    <app-file-uploader
                      (pending)="handleUploading($event)"
                      [customName]="item.description"
                      [tagName]='item.tag'
                      [formControl]='control'
                      [multiple]="item.multiple">
                    </app-file-uploader>
                  }
                </div>
              </div>
            </li>
            @if (!$last) {
              <br>
            }
          }
        </ol>
        <br>
        <div class='application-actions'>
          <button
            type='button'
            class='btn btn-secondary'
            [routerLink]='cancelUrl'>
            <span>
              Wstecz
            </span>
          </button>
          <button
            [disabled]="pending() || uploading()"
            (click)='submitAndGoNext()'
            type='button'
            class='btn btn-primary'>
            <span>Zatwierdź i przejdź do podpisania</span>
          </button>
        </div>
      </form>
    </div>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
